function HeaderView() {
  return (
    <h1 className="brand">Aseavria</h1>
  );
}

export default HeaderView;
